import { useState } from "react";

export default function ConfidenceDisclosure({ testId, inline = false }) {
  const [open, setOpen] = useState(false);

  return (
    <button
      type="button"
      data-testid={testId}
      data-tooltip="Less certain"
      data-open={open ? "true" : "false"}
      className={`confidence-chip confidence-chip--uncertain${inline ? " is-inline" : ""}`}
      title="Less certain"
      aria-label="Less certain"
      aria-expanded={open}
      onClick={(event) => {
        event.stopPropagation();
        setOpen((value) => !value);
      }}
      onBlur={() => setOpen(false)}
      onKeyDown={(event) => {
        if (event.key === "Escape") {
          setOpen(false);
          event.currentTarget.blur();
        }
      }}
    >
      ?
    </button>
  );
}
